<script setup lang="ts"></script>
<template>
  <section class="promo-section">
    <h2 class="promo-title">Почему стоит зарегистрироваться прямо сейчас</h2>
    <div class="promo-cards-grid">
      <div class="promo-card">
        <img
          class="promo-card-icon"
          src="./images/right-arrow.svg"
          alt="Arrow"
        />
        <div class="promo-card-content">
          <h3 class="promo-card-title">
            Бесплатное первое участие в большом CRE Инвестиционный форум
          </h3>
        </div>
        <NuxtLink
          to="https://investforum.cre.ru/"
          target="_blank"
          class="promo-card-link"
          >Узнать больше</NuxtLink
        >
      </div>
      <div class="promo-card">
        <img
          class="promo-card-icon"
          src="./images/right-arrow.svg"
          alt="Arrow"
        />
        <div class="promo-card-content">
          <h3 class="promo-card-title">
            Доступ к профильным мероприятиям CRE в течение года
          </h3>
        </div>
      </div>
      <div class="promo-card">
        <img
          class="promo-card-icon"
          src="./images/right-arrow.svg"
          alt="Arrow"
        />
        <div class="promo-card-content">
          <h3 class="promo-card-title">
            Персональные скидки на все события медиахолдинга
          </h3>
        </div>
      </div>
      <div class="promo-card">
        <img
          class="promo-card-icon"
          src="./images/right-arrow.svg"
          alt="Arrow"
        />
        <div class="promo-card-content">
          <h3 class="promo-card-title">
            Первыми узнаёте о новых спецпроектах и закрытых мероприятиях
          </h3>
        </div>
      </div>
    </div>
    <div class="promo-note">И многое другое</div>
  </section>
</template>

<style scoped lang="scss">
@use './styles/styles.scss' as *;
.promo-section {
  position: relative;
  padding-bottom: 73px;

  @media (max-width: $tablet-view) {
    padding-bottom: 90px;
  }

  @media (max-width: $mobile-view) {
    padding-bottom: 40px;
  }

  .promo-title {
    color: var(--dark-charcoal, #313030);
    @include font-regular;
    font-size: 64px;
    line-height: 100%;
    margin: 63px 0 0 129px;
    width: 960px;
    max-width: calc(100% - 258px);

    @media (max-width: 1205px) {
      max-width: calc(100% - 60px);
      margin: 63px 0 0 30px;
    }

    @media (max-width: $tablet-view) {
      margin-top: 90px;
      font-size: 46px;
      width: 770px;
    }

    @media (max-width: $mobile-view) {
      max-width: calc(100% - 40px);
      margin: 40px 0 0 20px;
      font-size: 32px;
    }
  }

  .promo-note {
    color: var(--ice, #8497e0);
    @include font-medium;
    font-size: 32px;
    line-height: 130%;
    margin: 26px 129px 0 auto;
    width: fit-content;

    @media (max-width: 1205px) {
      max-width: calc(100% - 60px);
      margin: 26px 30px 0 auto;
    }

    @media (max-width: $tablet-view) {
      font-size: 24px;
      margin-top: 30px;
    }

    @media (max-width: $mobile-view) {
      font-size: 16px;
      margin-top: 20px;
    }
  }

  .promo-cards-grid {
    display: flex;
    gap: 10px;
    max-width: calc(100% - 258px);
    margin: 63px 129px 0;

    @media (max-width: 1205px) {
      max-width: calc(100% - 60px);
      margin: 63px 30px 0;
    }

    @media (max-width: $tablet-view) {
      margin-top: 30px;
    }

    @media (max-width: $mobile-view) {
      margin-top: 40px;
      max-width: calc(100% - 40px);
      flex-direction: column;
    }

    .promo-card {
      background: #ffffff;
      padding: 30px 20px;
      display: flex;
      flex-direction: column;
      gap: 30px;
      flex: 1;
      position: relative;

      @media (max-width: $mobile-view) {
        padding: 20px;
        gap: 20px;
        flex-direction: row;
        flex-wrap: wrap;
      }

      .promo-card-icon {
        width: 51px;
        height: 49px;

        @media (max-width: $mobile-view) {
          width: 40px;
          height: 38px;
        }
      }

      .promo-card-content {
        display: flex;
        flex-direction: column;
        gap: 10px;

        @media (max-width: $mobile-view) {
          width: calc(100% - 70px);
        }

        .promo-card-title {
          color: var(--chiness-black, #111111);
          @include font-regular;
          font-size: 32px;
          line-height: 130%;
          margin: 0;

          @media (max-width: $tablet-view) {
            font-size: 18px;
          }

          @media (max-width: $mobile-view) {
            font-size: 16px;
          }
        }
      }

      .promo-card-link {
        color: var(--tangerine, #f26628);
        @include font-medium;
        font-size: 24px;
        line-height: 100%;
        text-decoration: underline;

        @media (max-width: $tablet-view) {
          font-size: 24px;
        }

        @media (max-width: $mobile-view) {
          font-size: 16px;
          margin-left: auto;
        }
      }
    }
  }
}
</style>
